import { CardBrand } from "../enums";
import type {
  PaymentMethodsProps,
  DealerMethodsPaymentsProps,
  BrandsPaymentsProps,
} from "../../../store/modules/DealerCare/types.store";

const VALID_BRANDS = Object.values(CardBrand).map((brand) =>
  brand.toLowerCase(),
);

function isBrandValid(brandName: string): boolean {
  const normalized = brandName?.trim().toLowerCase() || "";
  return VALID_BRANDS.some((valid) => valid === normalized);
}

function sanitizeBrands(brands: BrandsPaymentsProps[]): BrandsPaymentsProps[] {
  return brands.map((brand) => {
    const isValid = isBrandValid(brand.description) || isBrandValid(brand.id);
    return {
      ...brand,
      enabled: isValid ? brand.enabled : false,
    };
  });
}

function sanitizeMethods(
  methods: DealerMethodsPaymentsProps[],
): DealerMethodsPaymentsProps[] {
  return methods.map((method) => ({
    ...method,
    brands: method.brands ? sanitizeBrands(method.brands) : method.brands,
  }));
}

export function sanitizePaymentMethodsBrands(
  paymentMethods: PaymentMethodsProps[],
): PaymentMethodsProps[] {
  if (!paymentMethods?.length) return paymentMethods || [];

  return paymentMethods.map((pm) => ({
    ...pm,
    methods: sanitizeMethods(pm.methods),
  }));
}
